"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pizzoli": {
    "81eeeeac": [{
      "hkey": "fd9ebefd",
      "slug": "bivio-pizzoli-cermone",
      "name": "Bivio Pizzoli-Cermone",
      "primary": true,
      "skipSearch": false
    }],
    "bivio-pizzoli": [{
      "hkey": "fd9ebefd",
      "slug": "bivio-pizzoli-cermone",
      "name": "Bivio Pizzoli-Cermone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2335d03a": [{
      "hkey": "fd9ebefd",
      "slug": "bivio-pizzoli-cermone",
      "name": "Bivio Pizzoli-Cermone",
      "primary": true,
      "skipSearch": false
    }],
    "cermone": [{
      "hkey": "fd9ebefd",
      "slug": "bivio-pizzoli-cermone",
      "name": "Bivio Pizzoli-Cermone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pizzoli"
    }],
    "fff2fbad": [{
      "hkey": "8cbf57cc",
      "slug": "marruci-san-lorenzo",
      "name": "Marruci-San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "marruci-san-lorenzo-di-pizzoli": [{
      "hkey": "8cbf57cc",
      "slug": "marruci-san-lorenzo",
      "name": "Marruci-San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;